export const getTrialTimeRemaining = (
  trialExpiresAt: number,
  short = false,
): string | null => {
  const nowSeconds = Math.trunc(Date.now() / 1000);
  const secondsLeft = trialExpiresAt - nowSeconds;

  if (secondsLeft <= 0) return null;

  const daysLeft = Math.ceil(secondsLeft / (24 * 60 * 60));

  if (daysLeft > 1) {
    return short ? `${daysLeft}d` : `${daysLeft} days`;
  }

  const hoursLeft = Math.max(1, Math.ceil(secondsLeft / 3600));
  return short
    ? `${hoursLeft}h`
    : `${hoursLeft} hour${hoursLeft !== 1 ? "s" : ""}`;
};
